<template>
  <section
    v-if="logos.length"
    class="ic-home-logos"
    aria-label="Alcune delle agenzie presenti su immaginacasa.com"
  >
    <!-- Clipped viewport at the page max-width: cards enter and leave exactly
         at the edges. The sequence is rendered twice so the -50% -> 0 track
         translate loops seamlessly (see home.css). aria-hidden on the whole
         marquee — it's decorative motion, the alt text on each logo carries
         the meaning. -->
    <div class="ic-home-logos__viewport">
      <ul class="ic-home-logos__track" :style="trackStyle">
        <li
          v-for="(item, i) in loop"
          :key="i"
          class="ic-home-logos__card"
        >
          <img
            class="ic-home-logos__img"
            :src="item.logo"
            :alt="item.name || 'Agenzia'"
            loading="lazy"
            decoding="async"
            aria-hidden="true"
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeAgencyLogos',
  props: {
    logos: { type: Array, default: () => [] },
  },
  computed: {
    // Two back-to-back copies keep the translateX loop seamless.
    loop() {
      return [...this.logos, ...this.logos];
    },
    trackStyle() {
      // Constant per-card speed regardless of how many agencies there are;
      // slow, per the design. Clamped so a handful of logos still crawl.
      const SECONDS_PER_CARD = 6;
      const duration = Math.max(this.logos.length * SECONDS_PER_CARD, 20);
      return { animationDuration: `${duration}s` };
    },
  },
};
</script>
